import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function ConfirmationModal({ show, onHide, title, content, onAcceptClick, onCancelClick }) {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {content}
            </Modal.Body>
            <Modal.Footer>
                <div className='w-100 d-flex justify-content-between'>
                    <Button variant='outline-dark' onClick={onCancelClick ?? onHide}>{'Cancel'}</Button>
                    <Button variant='primary' onClick={onAcceptClick ?? onHide}>{'Confirm'}</Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmationModal;